import { createSlice } from '@reduxjs/toolkit';

import setLivePreviewScenesReducer from './reducer/setLivePreviewScenesReducer';
import setSelectedSceneReducer from './reducer/setSelectedSceneReducer';
import setSizeReducer from './reducer/setSizeReducer';
import { LivePreviewState } from './types';

export const livePreviewInitialState: LivePreviewState = {
  areaTokens: [],
  scenes: [],
  size: 'small',
};

export const slice = createSlice({
  name: 'livePreview',
  initialState: livePreviewInitialState,
  reducers: {
    setLivePreviewScenesAction: setLivePreviewScenesReducer,
    setSelectedSceneAction: setSelectedSceneReducer,
    setSizeAction: setSizeReducer,
  },
});

export const { setLivePreviewScenesAction, setSelectedSceneAction, setSizeAction } = slice.actions;

const livePreviewReducer = slice.reducer;

export default livePreviewReducer;
